import type { Theme } from './theme';

const greenSpace = '#c0eaa6';
const water = '#82d5ee';
const building = '#ebebeb';
const road = '#ffffff';
const other = '#dddddd';
const whiteSpace = '#f4f4f4';
const halo = '#fff';

export const mapTheme: Theme = {
    hasCasings: true,
    background: whiteSpace,
    earth: whiteSpace,
    park: greenSpace,
    hospital: '#ffeae8',
    industrial: '#f8ffed',
    school: '#f2fef9',
    wood: greenSpace,
    pedestrian: '#ffffff',
    scrub: greenSpace,
    glacier: '#ffffff',
    sand: '#eff5e7',
    aerodrome: '#dbe7e7',
    runway: road,
    water,
    tunnel_other_casing: road,
    tunnel_other: road,
    tunnel_minor_casing: road,
    tunnel_minor: road,
    tunnel_medium_casing: road,
    tunnel_medium: road,
    tunnel_major_casing: road,
    tunnel_major: road,
    tunnel_highway_casing: road,
    tunnel_highway: road,
    buildings: building,
    other,
    minor_casing: '#e2e2e2',
    minor: road,
    medium_casing: '#e1e1e1',
    medium: road,
    major_casing: '#e3cfd3',
    major: road,
    highway_casing: '#ebcea2',
    highway: road,
    railway: '#bdbdbd',
    railway_tracks: road,
    boundaries: '#5c4a6b',
    waterway_label_halo: halo,
    waterway_label: '#a4cae1',
    bridges_other_casing: '#ffffff',
    bridges_other: road,
    bridges_minor_casing: '#e2e2e2',
    bridges_minor: road,
    bridges_medium_casing: '#e1e1e1',
    bridges_medium: road,
    bridges_major_casing: '#e3cfd3',
    bridges_major: road,
    bridges_highway_casing: '#ebcea2',
    bridges_highway: '#fefffc',
    roads_label: '#91888b',
    roads_label_halo: halo,
    ocean_label: '#ffffff',
    ocean_label_halo: '#a4cae1',
    peak_label: '#61bb5b',
    peak_label_halo: halo,
    subplace_label: '#757d91',
    subplace_label_halo: halo,
    city_circle: '#666666',
    city_circle_stroke: '#ffffff',
    city_label: '#787878',
    city_label_halo: halo,
    state_label: '#bdbdbd',
    state_label_halo: halo,
    country_label: '#9590aa',
    country_label_halo: halo,
};
